import React from "react"
import { graphql, useStaticQuery } from "gatsby"

import styled from "styled-components"

import ScrollButton from "../ScrollButton/ScrollButton"
import MyLink from "../../utils/checkExternalLink"

const Hero = () => {
  const {
    allPrismicHero: { edges },
  } = useStaticQuery(graphql`
    query {
      allPrismicHero {
        edges {
          node {
            data {
              heading {
                text
              }
              action_label {
                text
              }
              subheading {
                text
              }
              image {
                gatsbyImageData
              }
              action_link {
                url
              }
              video {
                url
              }
              video_mobile {
                url
              }
            }
            id
          }
        }
      }
    }
  `)

  const scrollToExplore = () => {
    const elem = document.getElementById("#focusAreas")
    const elemTopOffset = elem?.getBoundingClientRect().top

    window.scrollTo({
      top: elemTopOffset,
      behavior: "smooth",
    })
  }

  const {
    node: {
      data: {
        heading,
        subheading,
        action_link: { url },
        action_label: { text },
        video: { url: videoUrl },
        video_mobile: { url: videoMobile },
        image,
      },
    },
  } = edges[0]
  return (
    <Section>
      <VideoBg>
        <video
            autoPlay loop muted playsInline
            poster={image?.gatsbyImageData.images.fallback.src}>
            <source src={videoUrl} media="(min-width: 768px)" type="video/mp4"/>
            <source src={videoMobile} media="(max-width: 767px)" type="video/mp4"/>
        </video>
      </VideoBg>
      <Container>
        <ContentWrapper>
          <TextWrapper>
            <Heading>{heading.text}</Heading>
            <Subheading>{subheading.text}</Subheading>
          </TextWrapper>
          <LinkWrapper>
            <MyLink href={url} target={"_blank"}>
              {text}
            </MyLink>
          </LinkWrapper>
          <ScrollButton
            onClick={scrollToExplore}
            textColor={"#fff"}
            iconColor={"#fff"}
            label={"Scroll to explore"}
          />
        </ContentWrapper>
      </Container>
    </Section>
  )
}

export default Hero

const VideoBg = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
  }
`
const Section = styled.section`
  max-width: 100%;
  min-height: 294px;
  margin: 0 auto;
  position: relative;
  display: flex;
  align-items: center;

  &::before {
    position: absolute;
    content: "";
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: ${({ theme }) => theme.colors.third_color};
    z-index: -3;
  }

  @media (min-width: ${({ theme }) => theme.media.tablet_min}) {
    min-height: 550px;
  }
`

const Container = styled.div`
  ${({ theme }) => theme.container};
  width: 100%;
  margin-top: 5%;
`

const ContentWrapper = styled.div``
const TextWrapper = styled.div``
const Heading = styled.h1`
  font-size: 30px;
  line-height: 37px;
  color: #fff;
  margin-bottom: 0;
  text-transform: uppercase;

  @media (min-width: ${({ theme }) => theme.media.tablet_min}) {
    font-size: 64px;
    line-height: 78px;
  }
`
const Subheading = styled.p`
  font-size: 17px;
  line-height: 21px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 20px;

  @media (min-width: ${({ theme }) => theme.media.tablet_min}) {
    font-size: 32px;
    line-height: 39px;
    margin-bottom: 32px;
  }
`
const LinkWrapper = styled.div`
  a {
    ${({ theme }) => theme.primaryButton};
    margin-bottom: 5px;
    padding: 13px 17px;

    @media (min-width: ${({ theme }) => theme.media.tablet_min}) {
      margin-bottom: 20px;
    }
  }
`
